module.exports = __webpack_public_path__ + "static/img/code2.996b3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code2.png
// module id = kpwS
// module chunks = 128